function o(e){return typeof e=="object"&&e!==null}export{o as a};
